module.exports = __webpack_public_path__ + "r-v3/img/pen_off.e2ccacc8.svg";